const scrollToTop = () => {
  document.querySelector('.quiz .container').scrollIntoView({
    behavior: 'smooth',
  })
}

const registerNextBtns = async () => {
  for (const btn of document.querySelectorAll('.quiz-section button')) {
    btn.addEventListener('click', async () => {
      const base = btn.closest('.quiz-section')
      if (base.classList.contains('results')) {
        // Results
      } else if (base.classList.contains('email')) {
        const email = document.getElementById('email').value
        const validated = validateEmail(email)
        if (validated) {
          const result = document
            .querySelector('.result.selected')
            .querySelector('h2').innerText
          const response = await sendKlaviyoEvent(email, result)
          moveToNext(base)
          if (response.event.error || response.subscription.error) {
            console.error('something went wrong')
          }
          // moveToNext(base)
        } else {
          document.querySelector('.email-error').style.display = 'block'
        }
      } else if (base.classList.contains('landing')) {
        moveToNext(base)
      } else {
        // Regular steps
        const validated = validateAnswer(
          base.querySelector('input[type="radio"]').getAttribute('name')
        )
        if (!validated) {
          base.querySelector('.error').style.display = 'block'
        } else {
          if (base.nextElementSibling.classList.contains('calculating')) {
            const score = await calculateResults()
            if (score) {
              console.log('score: ' + score)
              const results = Array.from(
                document.querySelectorAll('.quiz-section.results > .result')
              )
              const result = results.filter((r) => {
                return (
                  Number(score) >= Number(r.dataset.min) &&
                  Number(score) <= Number(r.dataset.max)
                )
              })
              if (result.length) {
                result[0].style.display = 'block'
                result[0].classList.add('selected')
                moveToNext(base, true)
              }
            }
          } else {
            moveToNext(base)
          }
        }
      }
    })
  }
}

const sendKlaviyoEvent = async (email, result) => {
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify({ email, result }),
  }

  return fetch(
    'https://cultivate-cloud.netlify.app/.netlify/functions/klaviyo',
    options
  )
    .then((response) => response.json())
    .then((response) => {
      return response
    })
    .catch((err) => {
      return err
    })
}

const calculateResults = async () => {
  var score = 0
  const answers = document.querySelectorAll(
    '.answer input[type="radio"]:checked'
  )
  for (const answer of answers) {
    score += Number(answer.value)
  }
  return score
}

const validateEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

const registerSkipBtn = () => {
  const btn = document.querySelector('.skip')
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    const base = btn.closest('.quiz-section')
    moveToNext(base)
  })
}

const validateAnswer = (name) => {
  return document.querySelector(`input[name="${name}"]:checked`) !== null
}

const moveToNext = (base, email) => {
  var step
  if (email) {
    step = Number(
      document.querySelector('.quiz-section.email').getAttribute('data-section')
    )
  } else {
    step = Number(base.getAttribute('data-section')) + 1
  }
  base.classList.remove('active')
  document.querySelector(`[data-section="${step}"]`).classList.add('active')
  scrollToTop()
}

const registerAnswerChange = () => {
  for (const answer of document.querySelectorAll(
    '.quiz-section .answers .answer'
  )) {
    answer.addEventListener('click', async () => {
      const base = answer.closest('.quiz-section')
      base.querySelector('.error').style.display = 'none'
    })
  }
}

const registerEmailListener = () => {
  document.getElementById('email').addEventListener('input', () => {
    document.querySelector('.email-error').style.display = 'none'
  })
}

document.addEventListener('DOMContentLoaded', function () {
  registerNextBtns()
  registerAnswerChange()
  registerSkipBtn()
  registerEmailListener()
})
